// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"4eb1bd8e","804":"d8481d52","944":"0aedc68e"}[chunkId] + ".css";
};